import { api } from "../../lib/api";

export interface OpportunityMedia {
  id: string;
  kind: "image" | "video";
  url: string | null;
  thumbnailUrl: string | null;
  caption: string | null;
  position: number;
  status: string;
}

export interface Opportunity {
  id: string;
  title: string;
  slug: string | null;
  type: string;
  summary: string | null;
  body: string | null;
  coverUrl: string | null;
  ctaLabel: string;
  expectedYield: string | null;
  minTicket: string | null;
  publishedAt: string | null;
  viewCount: number;
  media: OpportunityMedia[];
}

export interface Interest {
  id: string;
  opportunityId: string;
  opportunityTitle: string | null;
  amountIntended: string | null;
  message: string | null;
  status: string;
  createdAt: string;
}

/** First ready image, mobile only ever renders `kind==='image'` (video/HLS deferred). */
export function coverImage(o: Opportunity): string | null {
  const img = o.media
    .filter((m) => m.kind === "image" && m.status === "ready")
    .sort((a, b) => a.position - b.position)[0];
  return img?.url ?? o.coverUrl;
}

export const listFeed = () =>
  api<{ data: Opportunity[]; nextCursor: string | null }>("/opportunities").then((r) => r.data);

export const getOpportunity = (id: string) =>
  api<{ opportunity: Opportunity }>(`/opportunities/${id}`).then((r) => r.opportunity);

export const expressInterest = (opportunityId: string, body: { amountIntended?: string; message?: string }) =>
  api<{ interest: Interest }>(`/opportunities/${opportunityId}/interest`, {
    method: "POST",
    body,
  }).then((r) => r.interest);

export const myInterests = () => api<{ data: Interest[] }>("/me/interests").then((r) => r.data);
